(ns motorsaif.web.pages.dashboard.requests.index
  (:require
   ["react-transition-group" :refer [CSSTransition SwitchTransition]]
   [motorsaif.web.online-state :as online-state]
   [goog.string :refer [format]]
   [motorsaif.frontend-routes :as routes]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.time :as time]
   [motorsaif.url :as url]
   [motorsaif.shared.chat :as shared-chat]
   [motorsaif.utils :as utils]
   [motorsaif.web.components :as c]
   [motorsaif.web.components.chat :as chat]
   [motorsaif.web.photos :as photos]
   [re-frame.core :as rf :refer [dispatch subscribe]]
   [reagent.core :as r]
   [reagent.ratom :as ra]))

;; Chat threads on left
;; Posts you make are automatically grouped into one that turn into its subthreads.
;; That parent thread is mixed in with all the individual threads a user has potentially responded to
;; No need for separate things anymore

(defn- last-msg [thread]
  (:message (last (sort-by (comp :date-time/created :message) < thread))))

(defn thread-avatar-letters [threads]
  (let [n (count threads)]
    (into [:div.thread-avatars]
          (conj (mapv (fn [{:keys [profile]}]
                        [c/avatar-letter profile {:class "xs white-border"}])
                      (take 4 threads))
                (when (> n 4)
                  [:div.avatar.letter.small.remainder.xs.white-border
                   (format "+%s" (- n 4))])))))

(defn request-thread
  [{:keys [thread request on-click]}]
  (let [{created :date-time/created
         id :db/id
         short-id :short/id
         {:user/keys [handle]} :owner
         :request/keys [object media description category]} request
        {:car/keys [year make model]} object
        category (:tag/title category)
        unread-count (count @(subscribe [:unread-requester-parent-messages id]))
        threads @(subscribe [:requester-thread id])
        request-type (utils/request-type->str (get-in request [:request/type :db/ident]))
        img (photos/thumbnail-src request)]
    [:div.request-thread.parent
     {:on-click on-click}
     (if img
       [:img {:src (photos/thumbnail-src request)}]
       [:div])
     [:div.info
      [:div.text.car (format "%s %s %s" year make model)]
      [:div.description description]
      [:div.bottom
       (when (seq threads)
         [:span.latest-replies [thread-avatar-letters threads]])
       ;; [:span.category category]
       [:span.request-type request-type]
       (when (> unread-count 0)
         [:span.unread.if-c (format "%s new" unread-count)])]
      [:div.top-right
       [:span.short-id short-id]]]]))

;; (defn chat-peeps [messa] )
;; {:db/id 17592186045886,
;;   :date-time/created #inst "2023-09-13T14:23:48.706-00:00",
;;   :message/body "your car",
;;   :message/from {:db/id 17592186045676, :user/handle "test"}}




(defn- msg-content-preview
  "Return text or media"
  [{:keys [thread request current-owner-id]}]
  (let [{:keys [messages touches participants]} thread
        {:message/keys [body from media]
         last-ts :date-time/created} (last-msg messages)
        ;; current-owner-id @(subscribe [:current-owner-id])
        ack true
        from-id (:db/id from)
        from-current-user? (= current-owner-id from-id)
        other-participant (shared-chat/other-participant {:thread thread
                                                          :request request
                                                          :current-owner-id current-owner-id})
        other-participant-id (:db/id other-participant)
        last-access (get-in touches [other-participant-id :touched/last-access])
        seen? (when last-access (time/after? last-access last-ts))]
    (def zz last-access)
    (def zb last-ts)

    [:div.content-preview
     (when media
       [:div.last-media
        (into [:div.photo-grid
               {:class (str "n-" (count media))}]
              (map (fn [itm]
                     (let [{media-id :db/id} itm
                           src (url/uploaded-media {:media itm
                                                    :size :med})]
                       ^{:key media-id}
                       [:div.media-item
                        [:img {:src src}]]))) media)

        (tr [:page.messages.media] [(count media)])])
     (when body [:div.last-msg
                 [:span.body body]
                 (when from-current-user?
                   [:span.tick-status
                    (cond
                      (and ack seen?)
                      [:span.read-receipt
                       [:i.fa-regular.fa-check]
                       [:i.fa-regular.fa-check]]
                      ack
                      [:span.message-ack
                       [:i.fa-regular.fa-check]])])])]))

(defn- child-reply
  [{:keys [profile thread-id request-id] :as argz}]
  (let [thread @(subscribe [:thread thread-id])
        {owner-id :db/id handle :user/handle} profile
        {:keys [messages]} thread
        {last-ts :date-time/created :as last-msg} (last-msg messages)
        unread-count (count @(subscribe [:unread-requester-messages thread-id]))]
    [:div.child-thread
     {:on-click #(rf/dispatch [:common/navigate! :requester-thread {:request-id request-id
                                                                    :owner-id owner-id}])}
     [:div.top
      [c/avatar-letter-with-handle {:owner profile
                                    :letter-class "med"
                                    :no-link true}]
      [:span.sep " • "]
      [:span.last-sent-time (time/ago-str last-ts)]]
     [:div.mid
      [msg-content-preview
       {:thread thread
        :current-owner-id @(subscribe [:current-owner-id])}]
      (when (> unread-count 0)
        [:span.unread.if-c
         (format "%s" unread-count)])]]))

(defn- other-reply [{:keys [request-id request thread] :as data}]
  (let [{created :date-time/created
         id :db/id
         short-id :short/id
         owner :owner
         :request/keys [object media description category]} request
        {:car/keys [year make model]} object
        category (:tag/title category)
        last-msg (last-msg (:messages thread))
        unread-count (count @(subscribe [:unread-responder-messages request-id]))
        img (photos/thumbnail-src request)]
    [:div.request-thread.other
     {:on-click
      #(rf/dispatch [:common/navigate! :responder-thread {:request-id id}])}
     (if img
       [:img {:src img}]
       [:div])
     [:div.top-right
      [:span.short-id short-id]]
     [:div.info
      [c/avatar-letter-with-handle {:owner owner
                                    :letter-class "xs"}]
      [:div.car (format "%s %s %s" year make model)]
      [:div.mid
       [msg-content-preview
        {:thread thread
         :request request
         :current-owner-id @(subscribe [:current-owner-id])}]
       ;; [msg-content-preview last-msg]
       (when (> unread-count 0)
         [:span.unread.if-c
          (format "%s new" unread-count)])]]]))

(defn thread-navigator [{:keys [*route-data]}]
  (let [;; *user-requests (subscribe [:current-owner-active-requests])
        *user-requests (subscribe [:current-owner-active-requests-with-messages])
        *responder-msgs (subscribe [:responder-threads-with-messages])
        *all-unread-responder-msgs (subscribe [:all-unread-responder-messages])
        *all-unread-requester-msgs (subscribe [:all-unread-requester-messages])
        ;; *route-params (subscribe [:route/parameters])
        *state (r/atom nil)
        *ra (ra/reaction

              (when-let [tab (condp = (:name (:data @*route-data))
                               :messages :my-tab
                               :requester-threads :requester-threads
                               :responder-threads :responder-threads
                               :requester-chat :requester-chat
                               nil)]
                (reset! *state tab)))]
    (fn [{:keys [*route-params]}]
      @*ra
      (when-let [state @*state]
        [:div.thread-navigator.content
         (if (= state :requester-threads)
           [c/header-with-back (tr :page.messages.requester-threads.title)
            {:subtitle (tr :page.messages.requester-threads.description)}]
           [c/header (tr :page.messages.inbox)])
         (when-not (= state :requester-threads)
           [c/tabs-section
            {:tabs [{:key :my-tab
                     :content [:div
                               [:span.title
                                "Active"
                                (when (seq @*all-unread-requester-msgs)
                                  [:span.unread
                                   (count @*all-unread-requester-msgs)])]]}
                    {:key :responder-threads
                     :content [:div
                               [:span.title
                                "History"]
                               (when (seq @*all-unread-responder-msgs)
                                 [:span.unread
                                  (count @*all-unread-responder-msgs)])]}]
             :active-tab state
             :on-tab-click (fn [tab-key]
                             (condp = tab-key
                               :my-tab (rf/dispatch [:common/navigate! :messages])
                               :responder-threads (rf/dispatch [:common/navigate! :responder-threads])))}])

         (condp = state

           :requester-threads
           (let [{:keys [request-id]} @*route-params
                 request @(subscribe [:current-owner-request request-id])
                 threads @(subscribe [:requester-thread request-id])]
             [:div.parent-thread
              [request-thread
               {:request request
                :on-click #(rf/dispatch [:common/navigate! :request {:id request-id}])}]
              (if (seq threads)
                (let [inner-sort (fn [msgs]
                                   (sort-by #(get-in % [:date-time/created]) > msgs))
                      sorted-threads (sort-by (comp inner-sort :messages :thread) > threads)]
                  (into [:div.threads]
                        (map #(child-reply (assoc % :request-id request-id)) sorted-threads)))
                [:div.container
                 [:h4.no-items (tr :page.messages.empty-responses)]])])

           :responder-threads
           [:div
            (if (seq @*responder-msgs)
              (let [inner-sort (fn [msgs]
                                 (sort-by #(get-in % [:message :date-time/created]) > msgs))
                    sorted-msgs (sort-by (comp inner-sort :messages :thread) > @*responder-msgs)]
                (into [:div.threads]
                      (map other-reply sorted-msgs)))
              [:div.container
               [:h4.no-items (tr :page.messages.empty-responded)]])])]))))

(defn chat-frame [{:keys [current-owner-id
                          from-id
                          thread-id
                          client-msgs
                          participant
                          *thread
                          touches
                          request]}]
  (let [short-id (:short/id request)]
    [:div.content.chat-frame
     ;; (do (def bzhe thread)
     ;;     nil
     ;;     )
     ;; TODO replace this with the target chatter's name
     [c/header-with-back
      (tr :page.messages.live-chat)
      (-> {:subtitle
           [:a.req-link
            {:href (routes/path-for :request {:id short-id})}
            (tr :general.request) " "
            [:span.short-id short-id]]}
          ;; If the guy got linked right into the msg, make the back button do something since no history.
          (cond-> (= (.-length js/window.history) 1)
            (assoc :back-fn #(rf/dispatch [:common/navigate! :messages]))))]
     [chat/main-chat {:request request
                      :thread-id thread-id
                      :touches touches
                      :participant participant
                      :client-msgs client-msgs
                      :from-id from-id
                      :current-owner-id current-owner-id
                      :*thread *thread}]]))

;; what's common here?
;; we need to distinguish HOW we are entering the chat.
;; two contexts,
;; someone messaged us
;; OR
;; we messaged someone
;; OR
;; We are ABOUT to message someone
;; so chats have 3 differnet things.
(defn chat-frame-wrap
  "Wraps chat frame passing in data from route and subscriptions"
  []
  (let [current-owner-id @(subscribe [:current-owner-id])
        {:keys [request-id owner-id]} @(subscribe [:route/parameters])

        request @(subscribe [:request request-id])

        client-msgs (subscribe [:client-msgs])
        {:keys [request thread-id from-id] :as argz}
        (condp = (get-in @(subscribe [:route/data]) [:data :name])
          :responder-thread (let [?msg @(subscribe [:responder-thread request-id])
                                  thread-id [request-id current-owner-id]]
                              (if ?msg ; thread exists
                                (assoc ?msg
                                       :thread-id thread-id
                                       :from-id current-owner-id)
                                ;; new response, thread does not exist
                                {:from-id current-owner-id
                                 :thread-id thread-id
                                 :request request}))
          :requester-thread
          (assoc @(subscribe [:requester-thread request-id owner-id])
                 :request-id request-id
                 :thread-id [request-id owner-id]
                 :request @(subscribe [:current-owner-request request-id])
                 :from-id owner-id))
        *thread (subscribe [:thread thread-id])
        *touched-reaction (ra/reaction
                            @(subscribe [:thread-messages thread-id])
                            (when (= @online-state/*state :online)
                              (rf/dispatch [:touch-topic thread-id {:topic-type :thread}])))]

    ;; (get-in @re-frame.db/app-db [:threads ahe])
    ;; @(subscribe [:thread-messages ahe])
    (r/create-class
      {:component-did-mount
       (fn []
         (rf/dispatch [:touch-topic thread-id {:topic-type :thread}]))
       :reagent-render
       (fn []
         @*touched-reaction
         [chat-frame {:current-owner-id current-owner-id
                      :from-id from-id
                      :thread-id thread-id
                      :client-msgs client-msgs
                      :request request
                      :*thread *thread}])})))



(defn- request-item [request]
  (let [{created :date-time/created
         id :db/id
         short-id :short/id
         {:user/keys [handle]} :owner
         :request/keys [object media description category]} request
        {:car/keys [year make model]} object
        category (:tag/title category)
        unread-count (count @(subscribe [:unread-requester-parent-messages id]))
        threads @(subscribe [:requester-thread id])
        request-type (utils/request-type->str (get-in request [:request/type :db/ident]))
        thumb-src (photos/thumbnail-src request)]
    [:div.request-thread
     {:on-click
      #(rf/dispatch [:common/navigate! :dash-request {:request-id id}])}
     (if thumb-src
       [:img {:src thumb-src}]
       [:div])
     [:div.info
      [:div..car (format "%s %s %s" year make model)]
      [:div.description description]
      [:div.bottom
       (when (seq threads)
         [:span.latest-replies [thread-avatar-letters threads]])
       ;; [:span.category category]
       [:span.request-type request-type]
       (when (> unread-count 0)
         [:span.unread.if-c (format "%s new" unread-count)])]
      [:div.top-right
       [:span.short-id short-id]]]]))

(defn requests-active []
  (let [*user-requests (subscribe [:current-owner-active-requests-with-messages])
        *loaded? (subscribe [:all-ajax-loaded? :bootstrap-data
                             :threads/active])]
    (rf/dispatch [:fetch-messages {:status :active}])
    (fn []
      (if (seq @*user-requests)
        (let [inner-sort (fn [msgs]
                           (sort-by #(get-in % [:date-time/created]) > msgs))
              sorted-requests (sort-by (comp inner-sort :messages) > @*user-requests)]
          [:div
           (into [:div.threads]
                 (map request-item sorted-requests))])
        [:div.container
         [:h4.no-items (tr :page.messages.empty-requests)]]))))

(defn requests-history []
  (let [*user-requests (subscribe [:current-owner-history-requests-with-messages])
        *loaded? (subscribe [:all-ajax-loaded? :bootstrap-data
                             :threads/resolved
                             :threads/expired])]
    (rf/dispatch [:fetch-messages {:status :resolved}])
    (rf/dispatch [:fetch-messages {:status :expired}])
    (fn []
      (when @*loaded?
        (if (seq @*user-requests)
         (let [inner-sort (fn [msgs]
                            (sort-by #(get-in % [:date-time/created]) > msgs))
               sorted-requests (sort-by (comp inner-sort :messages) > @*user-requests)]
           [:div
            (into [:div.threads]
                  (map request-item sorted-requests))])
         [:div.container
          [:h4.no-items (tr :page.messages.empty-requests)]])))))

(defn requests-main
  []
  (fn []
    (let [tab-state (get-in @(subscribe [:route/data]) [:data :tab])
          unread-count (count @(rf/subscribe [:all-unread-requester-messages]))]
      [:div.container-sm
       [c/tabs-section
        {:tabs [{:key :active
                 :content [:div
                           [:span.title
                            "Active"
                            (when (> unread-count 0)
                              [:span.unread
                              unread-count])]]}
                {:key :history
                 :content [:div
                           [:span.title
                            "History"]]}]
         :active-tab tab-state
         :on-tab-click (fn [tab-key]
                         (condp = tab-key
                           :active (rf/dispatch [:common/navigate! :dash-requests])
                           :history (rf/dispatch [:common/navigate! :dash-requests-history])))}]
       (condp = tab-state
         :active [requests-active]
         :history [requests-history])])))

(defn root []
  (let [*loaded-once? (r/atom false)
        *loaded? (subscribe [:all-ajax-loaded? :bootstrap-data])
        *switch (ra/reaction
                  (or @*loaded-once?
                      @*loaded?))
        *route-params (subscribe [:route/parameters])
        *route-data (subscribe [:route/data])
        *page-id (subscribe [:route/page-id])]
    (dispatch [:ensure-user])
    (r/create-class
      {:reagent-render
       (fn []
         [:<>
          [c/header "Requests"]
          [requests-main]])})))
